import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Row, Col } from "react-bootstrap";
import {
  fetchTMEActiveUsersData,
  fetchTMEActiveUserStatsData,
  fetchTMEExpiredMembersStatsData,
  fetchTMEExpiredMembersData,
  fetchTMEFormSubmissionData,
  fetchTMEStatsData,
} from "../../redux/reducers/apiSlice";
import { fetchExportApiData } from "../../redux/reducers/commonApiSlice";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import CmnFilters from "../lead-management/common/CmnFilters";
import TMEForm from "../Open-pages/trainer-member-engagement/TMEForm";
import CommonStructured from "../common-components/CommonStructured";
import TransformationImages from "./TransformationImages";
import MemberCheckinLogs from "../pt-trials/common/MemberCheckinLogs";
import WorkoutLogs from "../pt-trials/common/WorkoutLogs";
import DetailedLogs from "./DetailedLogs";
import MemberConsultationData from "./MemberConsultationData";
import TMEStats from "./TMEStats";
import TMEApprovalManager from "./TMEApprovalManager";
import TMEtabs from "./TMEtabs";
import { fetchCheckedInMembersData } from "../../redux/prospect-reducers/prospectSlice";
import BCAReport from "./bca-report/BCAReport";
import DetailModHeader from "../common-components/DetailModHeader";
import TrainerMemberMap from "./trainer-member-map/TrainerMemberMap";
import MemberAllProfiles from "./trainer-member-map/MemberAllProfiles";
import "../../styles/trainer-member/tme-trainer-analysis.css";

const extractMemberCheckinTimes = (checkinArray) => {
  let last_checkin_start_end_time = [];

  checkinArray?.length > 0 &&
    checkinArray.forEach((item) => {
      const itemValue = item.value;
      last_checkin_start_end_time.push(itemValue);
    });

  return {
    last_checkin_start_end_time: last_checkin_start_end_time.join(", "),
  };
};

const extractTrainerCheckinTimes = (checkinArray) => {
  let last_checkin_start_end_time1 = [];

  checkinArray?.length > 0 &&
    checkinArray.forEach((item) => {
      const itemValue = item.value;
      last_checkin_start_end_time1.push(itemValue);
    });

  return {
    last_checkin_start_end_time1: last_checkin_start_end_time1.join(", "),
  };
};

const TMELogsTable = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { tmeLoading } = useSelector((state) => state.api);
  const { checkedInMembersLoading } = useSelector((state) => state.prospects);
  const { exportData, exportLoading } = useSelector((state) => state.common);

  const tableRef = useRef(null);
  const mobileTableRef = useRef(null);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isTrainer = userInfoData?.account_type === "trainer";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [selectedTab, setSelectedTab] = useState(0);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedTrainer: isTrainer
      ? {
          label: userInfoData?.name || "",
          value: userInfoData?.uid || userInfoData?.user_id || "",
        }
      : "",
    selectedPtInterest: "",
    selectedCheckinDaysAgo: "",
    selectedWorkoutDaysAgo: "",
    selectedFitnessProfileStatus: "",
    selectedTrainerRatingStatus: "",
    selectedCheckinDaysAgo1: "",
    selectedApprovalStatus: "",
    selectedIsApproved: "",
    selectedApprovalManager: "",
    selExpiringInDays: "",
    isActive: "",
    selectedBCAStatus: "",
    selectedWorkoutGoal: "",

    selectedCheckinTime: [],
    selectedCheckinTime1: [],

    leadAddDateFrom: "",
    leadAddDateTo: "",
    lastCheckinDateFrom: "",
    lastCheckinDateTo: "",
    lastWorkoutDateFrom: "",
    lastWorkoutDateTo: "",
    lastCheckinDate1From: "",
    lastCheckinDate1To: "",
    approvalDateFrom: "",
    approvalDateTo: "",
    checkinDateFrom: "",
    checkinDateTo: "",
    expiredDateFrom: "",
    expiredDateTo: "",

    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    free_pt_consultation: allFilters.selectedPtInterest?.value || "",
    last_checkin_days_ago: allFilters.selectedCheckinDaysAgo?.value || "",
    last_workout_days_ago: allFilters.selectedWorkoutDaysAgo?.value || "",
    last_checkin_time_filter: "",
    trainer_last_checkin_time_filter: "",
    trainer_last_checkin_days_ago:
      allFilters.selectedCheckinDaysAgo1?.value || "",
    fitness_profile: allFilters.selectedFitnessProfileStatus?.value || "",
    is_current_trainer_rating_done:
      allFilters.selectedTrainerRatingStatus?.value || "",
    approval_required: allFilters.selectedApprovalStatus?.value || "",
    is_approved: allFilters.selectedIsApproved?.value || "",
    expiring_indays: allFilters.selExpiringInDays?.value || "",
    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
    last_checkin_from: allFilters.lastCheckinDateFrom || "",
    last_checkin_to: allFilters.lastCheckinDateTo || "",
    last_workout_from: allFilters.lastWorkoutDateFrom || "",
    last_workout_to: allFilters.lastWorkoutDateTo || "",
    trainer_last_checkin_from: allFilters.lastCheckinDate1From || "",
    trainer_last_checkin_to: allFilters.lastCheckinDate1To || "",
    aprv_rej_date_from: allFilters.approvalDateFrom || "",
    aprv_rej_date_to: allFilters.approvalDateTo || "",
    filter_type: selectedTab === 1 ? "checked_in_notadded_to_tme" : "",
    mapped_type: "",
    first_bca_status: allFilters.isActive?.value || "",
    current_bca_status: allFilters.selectedBCAStatus?.value || "",
    workout_goal: allFilters.selectedWorkoutGoal?.label || "",
    expire_date_from: allFilters.expiredDateFrom || "",
    expire_date_to: allFilters.expiredDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
    remarks: "",
    editInfo: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);
  const [activeCardIndex, setActiveCardIndex] = useState(null);
  const [csvData, setCsvData] = useState(null);

  function onCloseModal() {
    setClickValues(iniClickValues);
  }

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setIsPage(0);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    setIsPage(0);
    setFilters(iniFilters);
    setAllFilters(iniAllFilter);
    setActiveCardIndex(null);
    setCsvData(null);
  };

  function getTMEStatsData(filters) {
    const { page, limit, filter_type, ...rest } = filters;

    dispatch(
      fetchTMEStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getTMEStatsDataV1(filters) {
    const { page, limit, filter_type, ...rest } = filters;

    dispatch(
      fetchTMEActiveUserStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getExpiredMembersStats(filters) {
    const { page, limit, filter_type, ...rest } = filters;

    dispatch(
      fetchTMEExpiredMembersStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getExpiredMembersData(filters) {
    const { filter_type, ...rest } = filters;

    dispatch(
      fetchTMEExpiredMembersData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getTMEFormSubmissionData(filters) {
    dispatch(
      fetchTMEFormSubmissionData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getTMEActiveUserFormSubmissionData(filters) {
    const { filter_type, ...rest } = filters;

    dispatch(
      fetchTMEActiveUsersData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getCheckedinMembers(filters) {
    dispatch(
      fetchCheckedInMembersData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getCombineReload() {
    if (selectedTab === 0) {
      getTMEStatsData(filters);
      getTMEFormSubmissionData(filters);
    } else if (selectedTab === 1) {
      getCheckedinMembers(filters);
    } else if (selectedTab === 2 || selectedTab === 4) {
      getTMEStatsDataV1(filters);
      getTMEActiveUserFormSubmissionData(filters);
    } else if (selectedTab === 3) {
      getExpiredMembersStats(filters);
      getExpiredMembersData(filters);
    }
  }

  function getExportEndpoint() {
    if (selectedTab === 0) {
      return "/member_engagement";
    } else if (selectedTab === 1) {
      return "/member_engagement/active_user";
    } else if (selectedTab === 2 || selectedTab === 4) {
      return "/member_engagement/active_user";
    } else if (selectedTab === 3) {
      return "/member_engagement/expired_user";
    }
    return "/member_engagement";
  }

  function getExportFilterType() {
    if (selectedTab === 0) {
      return "checked_in_added_to_tme";
    } else if (selectedTab === 1) {
      return "checked_in_notadded_to_tme";
    } else if (selectedTab === 2 || selectedTab === 4) {
      return "mapped_data";
    } else if (selectedTab === 3) {
      return "";
    }
    return "all";
  }

  function getExportedData() {
    const { page, limit, ...rest } = filters;
    dispatch(
      fetchExportApiData({
        method: "GET",
        endpoint: getExportEndpoint(),
        payload: {
          filters: {
            ...rest,
            is_export: 1,
            filter_type: getExportFilterType(),
          },
        },
        token: userInfoData?.token,
      })
    );
  }

  const onClickExportBtn = () => {
    setCsvData(null);
    getExportedData();
  };

  useEffect(() => {
    const { last_checkin_start_end_time } = extractMemberCheckinTimes(
      allFilters.selectedCheckinTime
    );
    const { last_checkin_start_end_time1 } = extractTrainerCheckinTimes(
      allFilters.selectedCheckinTime1
    );

    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      free_pt_consultation: allFilters.selectedPtInterest?.value || "",
      last_checkin_days_ago: allFilters.selectedCheckinDaysAgo?.value || "",
      last_checkin_time_filter: last_checkin_start_end_time || "",
      last_workout_days_ago: allFilters.selectedWorkoutDaysAgo?.value || "",
      trainer_last_checkin_days_ago:
        allFilters.selectedCheckinDaysAgo1?.value || "",
      trainer_last_checkin_time_filter: last_checkin_start_end_time1 || "",
      is_current_trainer_rating_done:
        allFilters.selectedTrainerRatingStatus?.value || "",
      approval_required: allFilters.selectedApprovalStatus?.value || "",
      is_approved: allFilters.selectedIsApproved?.value || "",
      expiring_indays: allFilters.selExpiringInDays?.value || "",
      fitness_profile: allFilters.selectedFitnessProfileStatus?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
      last_checkin_from: allFilters.lastCheckinDateFrom || "",
      last_checkin_to: allFilters.lastCheckinDateTo || "",
      last_workout_from: allFilters.lastWorkoutDateFrom || "",
      last_workout_to: allFilters.lastWorkoutDateTo || "",
      trainer_last_checkin_from: allFilters.lastCheckinDate1From || "",
      trainer_last_checkin_to: allFilters.lastCheckinDate1To || "",
      aprv_rej_date_from: allFilters.approvalDateFrom || "",
      aprv_rej_date_to: allFilters.approvalDateTo || "",
      checkin_start_date: allFilters.checkinDateFrom || "",
      checkin_end_date: allFilters.checkinDateTo || "",
      filter_type:
        selectedTab === 1
          ? "checked_in_notadded_to_tme"
          : activeCardIndex || "",
      mapped_type:
        (selectedTab === 2 || selectedTab === 4) && activeCardIndex
          ? activeCardIndex
          : "",
      first_bca_status: allFilters.isActive?.value || "",
      current_bca_status: allFilters.selectedBCAStatus?.value || "",
      workout_goal: allFilters.selectedWorkoutGoal?.label || "",
      expire_date_from: allFilters.expiredDateFrom || "",
      expire_date_to: allFilters.expiredDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.selectedPtInterest,
    allFilters.selectedCheckinDaysAgo,
    allFilters.selectedCheckinDaysAgo1,
    allFilters.selectedWorkoutDaysAgo,
    allFilters.selectedFitnessProfileStatus,
    allFilters.selectedTrainerRatingStatus,
    allFilters.selectedApprovalStatus,
    allFilters.selectedIsApproved,
    allFilters.selExpiringInDays,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.lastCheckinDateFrom,
    allFilters.lastCheckinDateTo,
    allFilters.lastWorkoutDateFrom,
    allFilters.lastWorkoutDateTo,
    allFilters.lastCheckinDate1From,
    allFilters.lastCheckinDate1To,
    allFilters.selectedCheckinTime,
    allFilters.selectedCheckinTime1,
    allFilters.approvalDateFrom,
    allFilters.approvalDateTo,
    allFilters.checkinDateFrom,
    allFilters.checkinDateTo,
    allFilters.expiredDateFrom,
    allFilters.expiredDateTo,
    activeCardIndex,
    selectedTab,
    allFilters.selectedWorkoutGoal,
    allFilters.isActive,
    allFilters.selectedBCAStatus,
  ]);

  useEffect(() => {
    getTMEStatsData(filters);
    getTMEStatsDataV1(filters);
    getExpiredMembersStats(filters);
  }, [
    filters.gym_id,
    filters.trainer_id,
    filters.free_pt_consultation,
    filters.last_checkin_days_ago,
    filters.last_workout_days_ago,
    filters.last_checkin_time_filter,
    filters.trainer_last_checkin_time_filter,
    filters.trainer_last_checkin_days_ago,
    filters.fitness_profile,
    filters.is_current_trainer_rating_done,
    filters.approval_required,
    filters.is_approved,
    filters.start_date,
    filters.end_date,
    filters.last_checkin_from,
    filters.last_checkin_to,
    filters.last_workout_from,
    filters.last_workout_to,
    filters.trainer_last_checkin_from,
    filters.trainer_last_checkin_to,
    filters.aprv_rej_date_from,
    filters.aprv_rej_date_to,
    filters.first_bca_status,
    filters.workout_goal,
    filters.expire_date_from,
    filters.expire_date_to,
  ]);

  useEffect(() => {
    getCombineReload();
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    }
  }, [exportData]);

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Edit Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            clickValues.cardName === "no_PT_consultation_reason" ||
            clickValues.cardName === "physical_limitation" ||
            clickValues.cardName === "medical_history" ||
            clickValues.cardName === "previous_PT_experience" ||
            clickValues.cardName === "member_map"
              ? "mod-width-50p"
              : ""
          } ${
            clickValues.cardName === "bca_report" ||
            clickValues.cardName === "add"
              ? "mod-height-95vh"
              : clickValues.cardName === "member_view_details"
              ? "bg-white mod-min-height-95vh mod-width-70p"
              : ""
          }`}
        >
          {clickValues.cardName === "bca_report" ||
          clickValues.cardName === "member_map" ||
          clickValues.cardName === "member_view_details" ? (
            <DetailModHeader
              info={clickValues.rowData}
              onClose={onCloseModal}
              isOnlySubscription={true}
            />
          ) : (
            <ModalHeadAndClose
              title={`${
                clickValues.cardName === "edit" ||
                clickValues.cardName === "add"
                  ? ""
                  : clickValues.cardName === "member_map"
                  ? "Trainer Member Mapping"
                  : clickValues.cardName?.replace(/_/g, " ")
              }`}
              onClose={onCloseModal}
            />
          )}

          {clickValues.cardName === "no_PT_consultation_reason" ||
          clickValues.cardName === "physical_limitation" ||
          clickValues.cardName === "medical_history" ||
          clickValues.cardName === "previous_PT_experience" ? (
            <div className="discussionModalMessage mt30">
              <p className="message">
                {clickValues.remarks || "No Content Available"}
              </p>
            </div>
          ) : clickValues.cardName === "edit" ||
            clickValues.cardName === "add" ? (
            <TMEForm
              userInfoData={isTrainer ? userInfoData : clickValues.editInfo}
              isEdit={clickValues.cardName === "edit"}
              rowData={clickValues.rowData}
              callFunction={getCombineReload}
            />
          ) : clickValues.cardName === "transformation_images" ? (
            <TransformationImages rowData={clickValues.rowData} />
          ) : clickValues.cardName === "member_checkin_details" ||
            clickValues.cardName === "trainer_checkin_details" ? (
            <MemberCheckinLogs
              clickValues={clickValues}
              sendableStatsQPs={clickValues.sendableStatsQPs}
              from={"tme"}
            />
          ) : clickValues.cardName === "member_workout_details" ? (
            <WorkoutLogs clickValues={clickValues} from={"tme"} />
          ) : clickValues.cardName === "fitness_profile_logs" ||
            clickValues.cardName === "trainer_rating_logs" ? (
            <DetailedLogs
              from={clickValues.cardName}
              rowData={clickValues.rowData}
              userInfoData={userInfoData}
            />
          ) : clickValues.cardName === "consultation_data" ? (
            <MemberConsultationData
              rowData={clickValues.rowData}
              userInfoData={userInfoData}
              callFunction={getCombineReload}
              onCloseModal={onCloseModal}
            />
          ) : clickValues.cardName === "manage_approval_manager" ? (
            <TMEApprovalManager userInfoData={userInfoData} />
          ) : clickValues.cardName === "bca_report" ? (
            <BCAReport
              userInfoData={userInfoData}
              rowData={clickValues.rowData}
            />
          ) : clickValues.cardName === "member_map" ? (
            <TrainerMemberMap
              userInfoData={userInfoData}
              rowData={clickValues.rowData}
              closeModal={onCloseModal}
              callFunction={getCombineReload}
            />
          ) : clickValues.cardName === "member_view_details" ? (
            <MemberAllProfiles
              rowData={clickValues.rowData}
              userInfoData={userInfoData}
            />
          ) : null}
        </div>
      </Modal>

      <Row>
        <Col>
          <CommonStructured
            pageHeading={"Trainer and Member Engagement"}
            isReload={selectedTab === 4 ? null : getCombineReload}
            createBtnTxt={
              isAdmin
                ? "Manage Approval Manager"
                : isTrainer
                ? "Add New Engagement"
                : null
            }
            onClickCreateBtn={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: isAdmin
                  ? "manage_approval_manager"
                  : isTrainer
                  ? "add"
                  : "",
              }))
            }
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from="trainer-member-engagement"
            userInfoData={userInfoData}
            onClickReset={onResetFilters}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            isLoading={tmeLoading || checkedInMembersLoading}
            selectedTab={selectedTab}
            onClickExportBtn={selectedTab !== 4 ? onClickExportBtn : null}
            exportLoading={exportLoading}
            csvData={csvData}
            csvFileName={`tme_export_tab_${selectedTab}.csv`}
          />

          {(selectedTab === 0 || selectedTab === 2 || selectedTab === 3) && (
            <TMEStats
              activeCardIndex={activeCardIndex}
              setActiveCardIndex={setActiveCardIndex}
              tableRef={tableRef}
              mobileTableRef={mobileTableRef}
              selectedTab={selectedTab}
            />
          )}

          <TMEtabs
            userInfoData={userInfoData}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            selectedTab={selectedTab}
            handleTabSelect={handleTabSelect}
            setClickValues={setClickValues}
            callFunction={() => {
              getCombineReload();
              getCheckedinMembers(filters);
            }}
            activeCardIndex={activeCardIndex}
            setActiveCardIndex={setActiveCardIndex}
            tableRef={tableRef}
            mobileTableRef={mobileTableRef}
            allFilters={allFilters}
          />
        </Col>
      </Row>
    </>
  );
};

export default TMELogsTable;
